module.exports = __webpack_public_path__ + "img/logo-light.58efa9bd.png";